// items - array of models
// sort by fields - array of sort fields + sortDirections
// fieldManager - instance fieldsManager we use it to get fieldClassInstance -> sortValue

export default function sortByOperator(items:any[], sortByFields:any[], fieldsManager:any) {
    const sortFunctionsArray:any[] = [];
    const sortDirectionsArray:any[] = [];

    _.map(sortByFields, f=>{
        const Field = fieldsManager.get(f.field);
        if (Field) {
            sortFunctionsArray.push((model:any)=>Field.sortValue(model[f.field], model));
            sortDirectionsArray.push(f.sortDirection);
        }
    })

    // _.orderBy() throws error if empty arrays are passed for sortFunctionsArray and sortDirectionsArray
    return sortFunctionsArray.length > 0 ? _.orderBy(items, sortFunctionsArray, sortDirectionsArray) : items;
}
